module.exports = __webpack_public_path__ + "img/youhuiquan.f173ecf9.png";